import {AdapterField, InstrumentServiceDetails} from 'instruments/connections/ConnectionConstants';
import {TagUpdateObject} from 'schemas/tags/TagUtil';

export function buildTagUpdateObject(values: Record<string, string>): TagUpdateObject {
  const result: TagUpdateObject = {};
  for (const [fieldId, value] of Object.entries(values)) {
    result[fieldId] = {value: value?.trim() ?? ''};
  }
  return result;
}

export function getInitialValues(
  fields: Array<AdapterField>,
  instrumentServiceDetails?: InstrumentServiceDetails,
  gatewayFieldOverrides?: Record<string, string>
): Record<string, string> {
  const values: Record<string, string> = {};
  for (const field of fields) {
    if (gatewayFieldOverrides && gatewayFieldOverrides[field.id] != null) {
      values[field.id] = gatewayFieldOverrides[field.id];
    } else if (instrumentServiceDetails?.fields.hasOwnProperty(field.id)) {
      values[field.id] = instrumentServiceDetails.fields[field.id].value ?? '';
    } else {
      values[field.id] = field.defaultValue || '';
    }
  }
  return values;
}

export function applyAutoSyncLogic(
  changedFieldId: string,
  changedValue: string,
  allValues: Record<string, string>
): Record<string, string> {
  // Build merged view: allValues as baseline, overridden by the current change
  const merged = {...allValues, [changedFieldId]: changedValue};

  const needsCredentials = merged.per_user_login_required === 'true';
  const shouldDisableAutoSync = needsCredentials && (!merged.username?.trim() || !merged.password?.trim());

  if (shouldDisableAutoSync && merged.enable_auto_sync === 'true') {
    return {...merged, enable_auto_sync: 'false'};
  }
  return merged;
}
